module.exports = __webpack_public_path__ + "static/media/switch.dd6eced5.mp3";